// Two different containers, both hidden from the user's project lists.
//
// 'template' holds copies a user made FROM the gallery (My Templates, which they
// browse and edit). 'template_source' holds the copies a user's own submissions
// produce, which are published snapshots and are never browsed: they are reached
// only through the template panel on the source story.
export const CONSUMED_TEMPLATES_CATEGORY = 'template';
export const PUBLISHED_TEMPLATES_CATEGORY = 'template_source';

export const CONSUMED_TEMPLATES_PROJECT_NAME = 'My Templates';

export function publishCopyPath(copy: { storyUniqueId: string | null; projectUniqueId: string }): string {
  return copy.storyUniqueId ? `/story/edit/${copy.storyUniqueId}?publish=1` : `/project/${copy.projectUniqueId}`;
}

export function isTemplateProjectCategory(category: string | null | undefined): boolean {
  return category === CONSUMED_TEMPLATES_CATEGORY || category === PUBLISHED_TEMPLATES_CATEGORY;
}
